module.exports = __webpack_public_path__ + "img/error.42097e33.png";